import React, { useState } from 'react';

import qs from 'qs';

import {
    Grid,
    Box,
    H2,
    FieldText,
} from '@saladbob/sassafras';


import getSite from '../../../crud/getSite';
import getHostBySlug from '../../../crud/getHostBySlug';
import Blocks from '../../../components/blocks/Blocks';
import Layout from '../../../components/Layout';
import HostLayout from '../../../components/hosts/Layout';
import CourtListing from '../../../components/brackets/CourtListing';
import Winners from '../../../components/brackets/Winners';

// Crud
import { publishedByTournament, publishedByTournamentFinished } from '../../../crud/gql/Brackets';
import fetchGql from '../../../crud/fetchGql';

import type { NextPageWithLayout, PageProps } from '../../_app';

import Host from '../../../types/Host';
import { BracketDepth } from '../../../types/Bracket';

type Props = {
    host: Host,
    bracket?: BracketDepth,
    Header: React.FC,
};

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking', // can also be true or 'blocking'
    }
}

export async function getStaticProps({ params }) {
    if (!params.id || params.id === 'undefined') {
        return {
            notFound: true,
        }
    }

    const site = await getSite();
    const host = await getHostBySlug(process.env.NEXT_PUBLIC_API_URL, params.id);

    if (!host) {
        return {
            notFound: true,
        }
    }

    const brackets = await fetchGql({
        query: host.activeTournament?.status === 'finished' ? publishedByTournamentFinished : publishedByTournament,
        variables: {
            id: host.activeTournament.id,
        },
    });

    return {
        props: {
            metaTitle: host?.name,
            bracket: brackets.data.Brackets.docs[0] || null,
            host,
            ...site,
        },
    }
}

const Page: NextPageWithLayout<Props> = ({ host, bracket }) => {
    if (host.activeTournament?.status == 'finished') {
        return (<Winners tournament={host?.activeTournament} bracket={bracket} />);
    }
    if (bracket?.courts?.length > 0) {
        return (<CourtListing host={host} courts={bracket.courts} bracketId={bracket.id} />);
    }
    return (<Blocks blocks={host.layout} />);
};

Page.getLayout = function getLayout(page: React.ReactElement, pageProps: PageProps & Props ) {
    let currentPage = 'about';
    if (pageProps.host?.activeTournament?.status === 'finished') {
        currentPage = 'winners';
    } else if (pageProps.bracket) {
        currentPage = 'brackets';
    }
    return (
        <Layout { ...pageProps }>
            <HostLayout page={currentPage} brackets={pageProps.bracket ? true : false} {...pageProps}>
                {page}
            </HostLayout>
        </Layout>
    )
}

export default Page;